import { Component, OnInit } from "@angular/core";
import { DataService } from "src/app/data.service";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-all-reports",
  templateUrl: "./all-reports.component.html",
  styleUrls: ["./all-reports.component.scss"]
})
export class AllReportsComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  reportId = "";
  mode = "";
  reports = [];
  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.getReport();
    // this.route.queryParams.subscribe((params) => {
    //   this.mode = this.route.snapshot.params.mode;
    //   this.reportId = this.route.snapshot.params.id;
    // });
  }
  displayedColumns: string[] = [
    "del",
    "labelname",
    "createdby",
    "createddate",
    "modifiedby",
    "modifieddate"
  ];
  dataSource: any[] = [];

  reportEdit(id: any, name: any) {
    console.log(id);
    console.log(name);
    this.router.navigateByUrl("home/report/edit/" + name + "/" + id);
  }
  delete(id: number) {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }

    this.isLoading = true;
    this.dataService
      .deleteReport(organizationid, domain, subdomain, id)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // alert("Are you sure?")
            window.location.reload();

            this.isLoading = false;
          } else {
            console.log("error while deleting");
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
        }
      );
  }
  getReport() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    // const domain = localStorage.getItem("domain");
    // const subdomain = localStorage.getItem("subdomain");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );

    this.isLoading = true;
    this.dataService.getReports(organizationid, domain, subdomain).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // alert("Are you sure?")
          // this.router.navigate(['home/globalaction'])
          // window.location.reload();
          this.reports = res.data.report;
          if (this.reports != null) {
            this.dataSource = this.reports.map((report) => ({
              id: report.id,
              labelname: report.reportlabel,
              name: report.reportname,
              createdby: report.createdby,
              modifieddate: report.modifieddate,
              modifiedby: report.modifiedby,
              createddate: report.createddate
            }));
          }
          this.isLoading = false;
        } else {
          console.log("error in getting data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
